// 작성자 표시 이름의 머리글자(최대 2자). 한글 이름은 첫 글자, 영문 "Gigone Lee"는 "GL".
export function formatMemoAuthorInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  const initials = words.map((word) => word[0]?.toUpperCase() ?? "").join("");
  return initials === "" ? "?" : initials;
}

// 카드/스트립 미리보기용 한 줄 요약이다. 줄바꿈/연속 공백을 한 칸으로 바꾸고 max 길이로 자른다.
export function truncateMemo(content: string, max = 80): string {
  const normalized = content.trim().replace(/\s+/g, " ");
  if (normalized.length <= max) {
    return normalized;
  }
  return normalized.slice(0, max - 1).trimEnd() + "…";
}
